import { api } from '../../api/public'
import { Empty, Failed, Loading } from '../../components/Async'
import { useApi } from '../../components/useApi'

/** League announcements (FR-039k), replacing the retired software's own. */
export function Announcements() {
  const news = useApi((s) => api.announcements(s), [])
  if (news.state === 'loading') return <Loading what="announcements" />
  if (news.state === 'error') return <Failed what="Announcements" error={news.error} />

  return (
    <section>
      <h2>League news</h2>
      {news.data.length === 0 ? (
        <Empty>Nothing has been posted.</Empty>
      ) : (
        <ul className="news-list">
          {news.data.map((n) => (
            <li key={n.id}>
              <h3>{n.title}</h3>
              <time dateTime={n.posted_at}>{n.posted_at.slice(0, 10)}</time>
              <p>{n.body}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
